import type { WebsiteHeaderPhotoSchema_FullWidth_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const FULL_WIDTH_v1_1_1: WebsiteHeaderPhotoSchema_FullWidth_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',
  presentationLayout: 'fullWidth',
  photos: [],
};
